import _ from 'lodash';
import React from 'react';

import {formatDate} from 'utils/datetime';
import {
  KYC_SECTION_TYPES,
  KYC_SECTION_STATUSES,
  VALID,
  EXPIRED,
  getKycSectionStatus
} from 'ducks/bookings';
import StatusBox from 'components/StatusBox';
import Button from 'components/Button';

import {
  KycDocumentsTable,
  KycIdentityVerificationsTable,
  KycVisaVerificationsTable,
  KycAddressHistoryTable,
  KycRequestDocumentTable
} from './components';

import './styles.css';

const getStatusText = ({status, selectedSection}) => {
  const {label} = status;

  if (_.isNil(selectedSection.expiryDate)) {
    return label;
  }

  const date = formatDate(selectedSection.expiryDate);

  if (label === KYC_SECTION_STATUSES[EXPIRED].label) {
    return `${label} - ${date}`;
  }

  if (label === KYC_SECTION_STATUSES[VALID].label) {
    return `${label} - EXPIRES ${date}`;
  }

  return label;
};

const KycMainContent = ({
  verifications,
  addressHistory,
  currentAddress,
  selectedSection,
  verifyButtonHandler,
  addAddressHandler,
  confirmCurrentAddressHandler,
  documentRequests,
  deleteDocument
}) => {
  const {type, label, documents} = selectedSection;
  const poa = type === KYC_SECTION_TYPES.POA;
  const poid = type === KYC_SECTION_TYPES.POID;
  const visa = type === KYC_SECTION_TYPES.VISA;
  const status = getKycSectionStatus(selectedSection.status);
  const statusText = getStatusText({status, selectedSection});
  const disableVerify = poa && _.isNil(currentAddress);

  return (
    <div className="KycMainContent">
      <div className="content">
        <div className="status">
          <StatusBox status={statusText} color={status.color} />
        </div>
        <KycDocumentsTable
          documents={documents}
          sectionLabel={label}
          deleteDocument={deleteDocument}
        />

        {poid && (
          <KycIdentityVerificationsTable
            verifications={verifications}
            label={label}
          />
        )}

        {visa && (
          <KycVisaVerificationsTable
            verifications={verifications}
            label={label}
          />
        )}

        {poa && (
          <KycAddressHistoryTable
            addressHistory={addressHistory}
            confirmCurrentAddressHandler={confirmCurrentAddressHandler}
          />
        )}

        <KycRequestDocumentTable
          sectionType={type}
          documentRequests={documentRequests}
        />
      </div>
      <div className="fixedContent">
        {type === KYC_SECTION_TYPES.POA && (
          <Button white onClick={addAddressHandler}>
            Add Address
          </Button>
        )}
        <Button
          blue={!disableVerify}
          disabled={disableVerify}
          onClick={verifyButtonHandler}>
          Verify
        </Button>
      </div>
    </div>
  );
};

export default KycMainContent;
